<template>
      <q-dialog v-model="show" maximized @hide="() => {this.$emit('hide')}">
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>
                <translate>{{ label }}</translate>
              </q-toolbar-title>
              <q-btn v-close-popup flat round dense icon="close" />
            </q-toolbar>
          </q-header>
          <q-page-container>
            <GeneratorPage
              :id= "generatorId"
              :forms ="generatorForm"
              @action-button="(button, params, page) => this.$emit('editGenerator', button, params, page)"
            />
          </q-page-container>
        </q-layout>
      </q-dialog>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import GeneratorPage from '../../generator/generator/GeneratorPage.vue'

@Component({

  components: { GeneratorPage },
  props: {
    label: String,
    generatorId: Number,
    generatorForm: Array,
    show: Boolean
  }
})

class CarrierGeneratorModal extends Vue {

}
export default CarrierGeneratorModal
</script>

<style>

</style>
